'use client';

import type { EventNumber, Participant, ParticipantPlayType } from '@svs/nova-poolbetting/schema/sport';
import { CouponEventParticipants } from '@svs/nova-poolbetting/ui/Coupon';
import { useSearchParams } from 'next/navigation';
import type { ReactNode } from 'react';

type CouponEventParticipantsContainerProps = {
  participants?: (Participant | undefined)[];
  eventDescription: string;
  participantType?: ParticipantPlayType;
  eventNumber: EventNumber;
};

/**
 * Container for coupon event participants.
 *
 * @param root0 props
 * @param root0.eventDescription the description of the event to be displayed
 * @param root0.participantType the type of the participants to be displayed
 * @param root0.participants the participants for the event
 * @param root0.eventNumber the number of the event to be displayed, used to see if event is selected
 * @returns CouponEventParticipants component
 */
export function CouponEventParticipantsContainer({
  eventDescription,
  participantType,
  participants,
  eventNumber,
}: CouponEventParticipantsContainerProps): ReactNode {
  const searchParams = useSearchParams();
  const eventNumberParam = searchParams.get('event');
  const selectedEventNumber = eventNumberParam ? Number.parseInt(eventNumberParam, 10) : 1;
  return (
    <CouponEventParticipants
      className={`text-base font-medium sm:text-lg ${selectedEventNumber === eventNumber ? 'lg:text-primary-variant-fg' : 'text-layer-fg'}`}
      participants={participants}
      eventDescription={eventDescription}
      participantType={participantType}
    />
  );
}
